<template>
  <div class="csFundsDetail">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.csName" placeholder="BD名称" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.csPhone" placeholder="BD电话" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-date-picker v-model="time" type="daterange" :append-to-body="false" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" >
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllCsFund">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="735" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="BD名称" align="center" width="180" prop="name"></el-table-column>
        <el-table-column label="所属代理" align="center" width="180" prop="type"></el-table-column>
        <el-table-column label="联系方式" width="170" align="center" prop="phone"></el-table-column>
        <el-table-column label="已出帐金额" align="center" width="150" prop="outAccount"></el-table-column>
        <el-table-column label="未出账金额" align="center" width="150" prop="outStanding"></el-table-column>
        <el-table-column label="已提现金额" align="center" width="150" prop="withdrawMoney"></el-table-column>
        <el-table-column label="可提现余额" align="center" width="150" prop="withdrawAble"></el-table-column>
        <el-table-column label="提现中金额" align="center" width="150" prop="withdrawingMoney"></el-table-column>
        <el-table-column label="提现冻结" align="center" width="150" prop="withdrawForzenMoney"></el-table-column>
        <el-table-column label="冻结余额" align="center" width="150" prop="freezeMoney"></el-table-column>
        <el-table-column label="累计手续费" align="center" width="150" prop="serviceMoney"></el-table-column>
        <el-table-column label="累计税费" align="center" width="150" prop="rateMoney"></el-table-column>
        <el-table-column label="账户状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.state === '0'">正常</el-tag>
            <el-tag type="warning" v-if="scope.row.state === '1'">冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提现记录" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" plain size="small" @click="csWithdraw(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="310" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" plain v-if="scope.row.state === '0'" size="small" style="width: 80px;margin:0" @click="accountOperation(scope.row)">冻结账户</el-button>
            <el-button type="warning" plain v-if="scope.row.state === '1'" size="small" style="width: 80px;margin:0" @click="accountOperation(scope.row)">解冻账户</el-button>
            <el-button type="warning" plain size="small" style="width: 80px;margin:0" @click="showFrozenMoneyDialog(scope.row)">冻结余额</el-button>
            <el-button type="warning" plain size="small" style="width: 80px;margin:0" @click="unFrozen(scope.row.id)">解冻余额</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <cs-withdraws v-if="csWithdrawDialog" ref="csWithdraw"></cs-withdraws>
    <el-dialog :visible.sync="frozenMoneyDialog" width="20%" top="25vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false :close-on-press-escape = false :show-close = false @close="closeDialog"> 
      <el-card>
        <el-form ref="form" :model="request" label-position="right">
          <el-row>
            <el-col :span="24">
              <el-form-item><span>可提现金额：{{canUserMoney}}</span></el-form-item>
            </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                <el-form-item><span>&nbsp;&nbsp;&nbsp;&nbsp;冻结金额：</span><el-input v-model="frozenMoney" placeholder="冻结金额" style="width:150px" clearable></el-input></el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item><span>&nbsp;&nbsp;&nbsp;&nbsp;冻结原因：</span><el-input type="textarea" :rows="2" placeholder="冻结原因" v-model="reason" style="width:150px"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button style="background-color:#A9F5F2;margin: 0" @click="frozenMoneyDialog = false" size="small">取消</el-button>
        <el-button style="background-color:#A9F5A9" @click="frozenMoneyOperation" size="small">确定</el-button>
      </span>
    </el-dialog>
    <un-frozen v-if="unFrozenDialog" ref="unFrozen" @unfrozen-succeed="unFrozenSucceed"></un-frozen>
  </div>
</template>

<script>
import { csCapitalDetail, operationAccount, frozenBalance} from "../../../api/accountFunds/bdfunddetail";
import CsWithdraws from './bdWithdraws.vue'
import UnFrozen from './bdUnfrozenmoney.vue'
import { formatDate } from "../../../utils/date";

export default {
  components: {CsWithdraws, UnFrozen},
  inject: ["reload"],
  name: "CsFundsDetail",
  data() {
    return {
      request: {
        csName: '',
        csPhone: '',
        startTime: '',
        endTime: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 15},
      response: {data: [], total: 0},
      loading: false,
      csWithdrawDialog: false,
      time: '',
      frozenMoneyDialog: false,
      canUserMoney: '',
      frozenMoney: '',
      reason: '',
      item: '',
      unFrozenDialog: false
    };
  },
  methods: {

    /**
     * 获取代理资金列表
     */
    getAllCsFund() {
      this.request.startTime = this.time[0];
      this.request.endTime = this.time[1];
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      csCapitalDetail(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 代理提现详情
     */
    csWithdraw(id){
      this.csWithdrawDialog = true;
      this.$nextTick(()=>{
        this.$refs.csWithdraw.init(id);
      })
    },

    /**
     * 页码改变
     */
    currenChangeHandle(value){
      this.query.current = value;
      this.getAllCsFund();
    },

    /**
     * 重置
     */
    reset(){
      this.request.csName = "";
      this.request.csPhone = "";
      this.time = [];
      this.query.current = 1;
      this.getAllCsFund();
    },

    /**
     * 代理账号操作
     */
    accountOperation(item){
      this.$confirm('确认是否操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        operationAccount({identity: "cs", id: item.id, state: item.state === "0" ? "1" : 0}).then(result=>{
          if(result.code === "000000"){
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          this.getAllCsFund();
          }
        })
      })
    },

    /**
     * 冻结余额弹窗
     */
    showFrozenMoneyDialog(item){
      this.frozenMoneyDialog = true;
      this.canUserMoney = item.withdrawAble;
      this.item = item;
    },

    /**
     * 冻结余额
     */
    frozenMoneyOperation(){
      this.$confirm('确认是否操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(Number(this.frozenMoney <= 0)){
          this.$message({
            type: 'error',
            message: '冻结金额必须大于0!'
          });
          return;
        }
        if(Number(this.canUserMoney) < Number(this.frozenMoney)){
          this.$message({
            type: 'error',
            message: '冻结金额不能超过可提现金额!'
          });
          return;
        }
        frozenBalance({id: this.item.id, money: this.frozenMoney , reason: this.reason}).then(result=>{
          if(result.code === "000000"){
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.frozenMoneyDialog = false;
            this.getAllCsFund();
          }
        })
      })
    },

    /**
     * 冻结记录
     */
    unFrozen(id){
      this.unFrozenDialog = true;
      this.$nextTick(()=>{
        this.$refs.unFrozen.init(id);
      })
    },

    /**
     * 关闭弹窗
     */
    closeDialog(){
      this.canUserMoney = '';
      this.frozenMoney = '';
      this.reason = '';
      this.item = ''
    },

    /**
     * 解冻成功，重新请求
     */
    unFrozenSucceed(){
      this.getAllCsFund();
    }

  },
  created() {
    this.getAllCsFund();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.csFundsDetail {
  width: 100%;
  background-color: #ffffff;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/fundsaccount/bdfundsdetail.vue